// src/themes/light.js

export default {
  colors: {
    background: "#f5f8fa",
    textColor: "#333",
    sliderBgColor: "#fff",
    tableBgColor: "#fff"
  },
};
